<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #875c2c 0%, #d8a252 100%);">
            <i class="fa fa-sitemap text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Rastreabilidade Produção por Fórmula</h4>
            <small class="text-muted small">Consulte lote de matéria-prima até os lotes finais, ou o lote final até os lotes consumidos.</small>
          </div>
        </div>

        <div class="list-header-actions d-flex align-items-center flex-wrap gap-2 py-1 px-3 justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border flex-wrap">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2" style="min-width: 320px;">
              <b-form-radio-group
                v-model="filtroTipo"
                :options="tipoOptions"
                buttons
                button-variant="outline-primary"
                size="sm"
                class="w-100 flex-nowrap radio-trace">
              </b-form-radio-group>
            </div>

            <div class="search-pill-segment d-flex align-items-center px-2 border-left mr-2 form-search-wrapper">
              <b-form-input
                v-model="filtroLote"
                placeholder="Informe ao menos 2 caracteres do lote..."
                class="shadow-xs"
                style="font-size: 0.9rem;"
                @keydown.enter.native="pesquisar">
              </b-form-input>
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">CONSULTAR</span>
            </b-button>
          </div>
        </div>
      </div>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              :empty-text="emptyText"
              responsive
              hover
              small
              :busy.sync="isBusy"
              :items="lista"
              :fields="fieldsAtuais"
              @row-clicked="clicarLinha"
              :tbody-tr-class="rowClassSelecionado">
              <template #cell(QUANT_SALDO)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_SALDO) }}</span>
              </template>

              <template #cell(QUANT_INICIAL)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_INICIAL) }}</span>
              </template>

              <template #cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-button type="button" @click.stop.prevent="abrirDetalhe(row.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Detalhar rastreabilidade">
                    <i class="fa fa-search-plus"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      tipoOptions: [
        { text: 'Lote de Matéria-Prima', value: 'MP' },
        { text: 'Lote Final', value: 'FINAL' }
      ],
      fieldsMateriaPrima: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'LOTE', label: 'Lote', sortable: true, thStyle: { width: '140px' } },
        { key: 'PRODUTO_CODIGONOME', label: 'Produto', sortable: true },
        { key: 'CENTRO_ESTOQUE_CODIGONOME', label: 'Centro Estoque', sortable: true },
        { key: 'QUANT_INICIAL', label: 'Qtd. Inicial', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'QUANT_SALDO', label: 'Qtd. Saldo', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'PECAS_SALDO', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'TOTAL_PROCESSOS', label: 'Processos', sortable: true, class: 'text-center', thStyle: { width: '95px' } },
        { key: 'TOTAL_LOTES_FINAIS', label: 'Lotes Finais', sortable: true, class: 'text-center', thStyle: { width: '110px' } },
        { key: 'actions', label: '', class: 'text-center', thStyle: { width: '60px' } }
      ],
      fieldsLoteFinal: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'LOTE', label: 'Lote Final', sortable: true, thStyle: { width: '140px' } },
        { key: 'PROCESSO_ID', label: 'Processo', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'FORMULA_DESCRICAO', label: 'Fórmula', sortable: true },
        { key: 'PRODUTO_FINAL_CODIGONOME', label: 'Produto Final', sortable: true },
        { key: 'CENTRO_PRODUCAO_CODIGONOME', label: 'Centro Produção', sortable: true },
        { key: 'QUANT_SALDO', label: 'Qtd. Saldo', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'PECAS_SALDO', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'TOTAL_LOTES_MATERIA_PRIMA', label: 'Lotes MP', sortable: true, class: 'text-center', thStyle: { width: '95px' } },
        { key: 'TOTAL_APONTAMENTOS', label: 'Apont.', sortable: true, class: 'text-center', thStyle: { width: '95px' } },
        { key: 'actions', label: '', class: 'text-center', thStyle: { width: '60px' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    lista() { return this.$store.getters['producaoFormulaRastreabilidade/LISTA'] || [] },
    filtroTipo: {
      get() { return this.$store.getters['producaoFormulaRastreabilidade/FILTRO_TIPO'] },
      set(valor) { this.$store.commit('producaoFormulaRastreabilidade/SET_FILTRO_TIPO', valor) }
    },
    filtroLote: {
      get() { return this.$store.getters['producaoFormulaRastreabilidade/FILTRO_LOTE'] },
      set(valor) { this.$store.commit('producaoFormulaRastreabilidade/SET_FILTRO_LOTE', valor) }
    },
    registroSelecionadoId() { return this.$store.getters['producaoFormulaRastreabilidade/REGISTRO_SELECIONADO_ID'] },
    fieldsAtuais() {
      return this.filtroTipo === 'FINAL' ? this.fieldsLoteFinal : this.fieldsMateriaPrima
    },
    emptyText() {
      return this.filtroTipo === 'FINAL'
        ? 'Nenhum lote final localizado para a pesquisa informada'
        : 'Nenhum lote de matéria-prima localizado para a pesquisa informada'
    }
  },
  methods: {
    formatarNumero(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    clicarLinha(item) {
      this.$store.commit('producaoFormulaRastreabilidade/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return item.ID === this.registroSelecionadoId ? 'cec-row-selected' : ''
    },
    async pesquisar() {
      if (!this.filtroLote || String(this.filtroLote).trim().length < 2) {
        this.$bvToast.toast('Informe ao menos 2 caracteres do lote para pesquisar', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.isBusy = true
      try {
        await this.$store.dispatch('producaoFormulaRastreabilidade/GET_LISTA')
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao consultar rastreabilidade', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },
    limparFiltro() {
      this.$store.commit('producaoFormulaRastreabilidade/SET_LIMPAR')
    },
    abrirDetalhe(item) {
      const tipo = this.filtroTipo === 'FINAL' ? 'final' : 'mp'
      this.$router.push(`/producao/formula-rastreabilidade/cadastro/${tipo}/${item.ID}`)
    }
  }
}
</script>

<style scoped>
.list-header-actions {
  width: 100%;
  gap: 0.75rem;
}

.search-pill-responsive {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.search-pill-segment {
  min-width: 0;
}

.form-search-wrapper {
  flex: 1 1 260px;
  min-width: 220px;
}

.btn-filtrar-responsive {
  flex: 0 0 auto;
  white-space: nowrap;
}

.radio-trace .btn {
  flex: 1 1 auto;
}

.table-finance tbody td {
  vertical-align: middle !important;
}

@media (max-width: 1199.98px) {
  .search-pill-responsive {
    flex-basis: 100%;
  }
}

@media (max-width: 991.98px) {
  .list-header-actions {
    align-items: stretch !important;
  }

  .search-pill-responsive {
    border-radius: 1.1rem !important;
    padding: 0.5rem !important;
  }

  .search-pill-segment {
    width: 100%;
    border-left: 0 !important;
    margin-right: 0 !important;
    padding: 0.25rem 0 !important;
  }

  .form-search-wrapper {
    flex-basis: 100%;
    min-width: 100%;
  }

  .btn-filtrar-responsive {
    width: 100%;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/producao/producao-formula-rastreabilidade/ProducaoFormulaRastreabilidadeListagem.vue